export interface RiskDomain {
  label: string;
  level: string | undefined;
  summary: string;
}

export interface RiskBreakdownProps {
  domains: RiskDomain[];
}

const LEVEL_COLORS: Record<string, string> = {
  LOW: "#27ae60",
  MEDIUM: "#f39c12",
  HIGH: "#e74c3c",
  UNKNOWN: "#95a5a6",
};

const LEVEL_LABELS: Record<string, string> = {
  LOW: "Low Risk Indicators",
  MEDIUM: "Moderate Risk Indicators",
  HIGH: "Severe Risk Indicators",
  UNKNOWN: "Unknown",
};

export function RiskBreakdown({ domains }: RiskBreakdownProps) {
  if (domains.length === 0) return null;

  return (
    <div className="intel-section-group">
      <h2 className="intel-section-header">Risk Breakdown</h2>
      <p className="intel-section-desc">At-a-glance risk indicator status across each intelligence domain.</p>
      <div className="intel-grid intel-grid-5">
        {domains.map((d) => {
          const lvl = d.level?.toUpperCase() ?? "UNKNOWN";
          const color = LEVEL_COLORS[lvl] ?? LEVEL_COLORS.UNKNOWN;
          const label = LEVEL_LABELS[lvl] ?? LEVEL_LABELS.UNKNOWN;
          return (
            <div
              key={d.label}
              className="intel-risk-domain-card card"
              style={{ borderLeftColor: color }}
            >
              <div className="intel-risk-domain-label">{d.label}</div>
              <span
                className="intel-risk-domain-badge"
                style={{ color, borderColor: color }}
              >
                {label}
              </span>
              <div className="intel-risk-domain-summary">{d.summary}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
